const translation = {
  custom: 'Dostosowanie',
  upgradeTip: {
    prefix: 'Zaktualizuj swój plan, aby',
    suffix: 'dostosować swoją markę.',
    title: 'Zmień swój plan',
    des: 'Zaktualizuj swój plan, aby dostosować swoją markę',
  },
  webapp: {
    title: 'Dostosuj markę aplikacji internetowej',
    removeBrand: 'Usuń zasilane przez Dify',
    changeLogo: 'Zmień obraz marki zasilany przez Brand',
    changeLogoTip: 'Format SVG lub PNG o minimalnym rozmiarze 40x40px',
  },
  app: {
    title: 'Dostosuj markę nagłówka aplikacji',
    changeLogoTip: 'Format SVG lub PNG o minimalnym rozmiarze 80x80px',
  },
  upload: 'Prześlij',
  uploading: 'Przesyłanie',
  uploadedFail:
    'Wystąpił problem podczas przesyłania obrazu, proszę spróbować ponownie.',
  change: 'Zmień',
  apply: 'Zastosuj',
  restore: 'Przywróć domyślne',
  customize: {
    contactUs: ' skontaktuj się z nami ',
    prefix: 'Aby dostosować logo marki w aplikacji, proszę',
    suffix: 'dla aktualizacji do wersji Enterprise.',
  },
}

export default translation
